import React, { useContext, useEffect } from "react";
import { Fragment, useState } from 'react'
import { Menu, Dialog, Transition } from '@headlessui/react'
import {
    Bars3Icon,
} from '@heroicons/react/24/outline'
import { SearchIcon, MapPinIcon as SolidMapPinIcon, CakeIcon, BuildingOfficeIcon as SolidBuildingOfficeIcon, ChevronDownIcon } from '@heroicons/react/24/solid'
import api from "../../api";
import Sidebar from "../../components/Sidebar";
import DateInput from "../../components/DateInput";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import CustomCombobox from "../../components/CustomCombobox";
import Badge from "../../components/Badge";

ChartJS.register(
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    ArcElement,
);

const options = [
    { name: 'Datos generales', href: '/reports/general-data-report' },
    { name: 'Cirugías', href: '/reports/surgery-report' },
    { name: 'Estudios', href: '/#' },
    { name: 'Medicamentos', href: '/reports/medication-report' },
]

const colors = [
    '#9747FF',
    '#28A5DD',
    '#EF5369',
    '#FF6C4B',
    '#F7C469',
    '#C46352',
    '#714433',
    '#412525',
    '#634258',
    '#6D6087',
    '#60A0B0',
    '#9AD1AA',
    '#307470',
    '#307470',
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function StudiesPage() {

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [loading, setLoading] = useState(true)
    const [studies, setStudies] = useState(undefined)
    const [data, setData] = useState(undefined);
    const [dataPieA, setDataPieA] = useState(undefined)
    const [dataPieB, setDataPieB] = useState(undefined)
    const [filters, setFilters] = useState({})
    const [fromDate, setFromDate] = useState(undefined)
    const [toDate, setToDate] = useState(undefined)
    const [studyFilter, setStudyFilter] = useState(undefined)

    const handleFromDate = (field, value) => setFromDate(value);
    const handleToDate = (field, value) => setToDate(value);
    const handleStudyFilter = (field, value) => setStudyFilter(value);

    useEffect(() => {
        api.studyReport.getMulti().then((response) => { setData(response); setLoading(false); })
    }, [])

    const saveFromDate = () => {
        setFilters((prev) => ({ ...prev, date_after: fromDate }))
    }

    const saveToDate = () => {
        setFilters((prev) => ({ ...prev, date_before: toDate }))
    }

    const saveStudyFilter = () => {
        setFilters((prev) => ({ ...prev, studyFilter: studyFilter }))
    }

    const deleteFromDate = () => {
        setFilters((prev) => ({ ...prev, date_after: undefined }))
        setFromDate(undefined)
    }

    const deleteToDate = () => {
        setFilters((prev) => ({ ...prev, date_before: undefined }))
        setToDate(undefined)
    }

    const deleteAllStudyFilter = () => {
        setFilters((prev) => ({ ...prev, studyFilter: undefined }))
        setStudyFilter(undefined)
    }

    const deleteStudyFilter = (value) => {
        setFilters((prev) => ({ ...prev, studyFilter: filters.studyFilter.filter((element) => element.id !== value) }))
        setStudyFilter(studyFilter.filter((element) => element.id !== value))
    }

    useEffect(() => {
        if (data) {
            setDataPieA({
                labels: data.clinicalStudies.data.filter((element) => element.quantity > 0).map((element) => element.name),
                datasets: [
                    {
                        data: data.clinicalStudies.data.filter((element) => element.quantity > 0).map((element) => element.quantity),
                        backgroundColor: colors,
                    }
                ]
            })
            setDataPieB({
                labels: data.ophthalmologicalStudies.data.filter((element) => element.quantity > 0).map((element) => element.name),
                datasets: [
                    {
                        data: data.ophthalmologicalStudies.data.filter((element) => element.quantity > 0).map((element) => element.quantity),
                        backgroundColor: colors,
                    }
                ]
            })
        }
    }, [data])

    const optionsPieA = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'left',
            },
            title: {
                display: true,
                text: 'Pacientes con orden de cirugía',
            }
        }
    };

    const optionsPieB = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'left',
            },
            title: {
                display: true,
                text: 'Pacientes que se sometieron a cirugía',
            }
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen h-full">
            <Sidebar currentScreen={'Reportes'} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {loading ?
                <div className="flex h-full items-center justify-center ">
                    <div className="w-16 h-16 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                </div> :
                <div className="md:pl-64 flex flex-col h-full">
                    <main className="flex-1 bg-white">
                        <div className="sticky top-0 z-10 md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-gray-100">
                            <button
                                type="button"
                                className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
                                onClick={() => setSidebarOpen(true)}
                            >
                                <span className="sr-only">Open sidebar</span>
                                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="flex flex-1 pb-4 ml-6 mt-5">
                            <Menu as="div" className="relative inline-block text-left">
                                <div>
                                    <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm ring-0 outline-0">
                                        Estudios
                                        <ChevronDownIcon className="-mr-1 h-5 w-5 text-white" aria-hidden="true" />
                                    </Menu.Button>
                                </div>
                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div className="py-1">
                                            {options.map((element) => (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <a
                                                            href={element.href}
                                                            className={classNames(
                                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                                'block px-4 py-2 text-sm'
                                                            )}
                                                        >
                                                            {element.name}
                                                        </a>
                                                    )}
                                                </Menu.Item>
                                            ))}
                                        </div>
                                    </Menu.Items>
                                </Transition>
                            </Menu>
                            <div className="h-10 border border-[#E5E7EB] mx-8 " />
                            <div className="flex gap-6">
                                <Menu as="div" className="relative inline-block text-left">
                                    <div>
                                        <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm text-black ring-0 outline-0">
                                            Fecha
                                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-black" aria-hidden="true" />
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="absolute z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div className="py-4 flex flex-col gap-3 px-5">
                                                <DateInput handleChange={handleFromDate} name='fromDate' label='Desde' />
                                                <DateInput handleChange={handleToDate} name='toDate' label='Hasta' />
                                                <div className="flex gap-3">
                                                    <button onClick={() => (deleteToDate(), deleteFromDate())} className="flex justify-center gap-2 py-2 px-2 w-full border border-[#D1D5DB] rounded-md shadow-sm text-sm font-medium bg-white">
                                                        Borrar filtros
                                                    </button>
                                                    <button onClick={() => (saveToDate(), saveFromDate())} className="flex justify-center gap-2 py-2 px-2 w-full border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary">
                                                        Aplicar filtro
                                                    </button>
                                                </div>
                                            </div>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                                <Menu as="div" className="relative inline-block text-left">
                                    <div>
                                        <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm text-black ring-0 outline-0">
                                            Estudios
                                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-black" aria-hidden="true" />
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="absolute z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div className="py-4 flex flex-col gap-3 px-5">
                                                <CustomCombobox multiple={true} required={true} options={studies} handleChange={handleStudyFilter} name='studies' label='Estudios' />
                                                <div className="flex gap-3">
                                                    <button onClick={() => deleteAllStudyFilter()} className="flex justify-center gap-2 py-2 px-2 w-full border border-[#D1D5DB] rounded-md shadow-sm text-sm font-medium bg-white">
                                                        Borrar filtros
                                                    </button>
                                                    <button onClick={() => saveStudyFilter()} className="flex justify-center gap-2 py-2 px-2 w-full border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary">
                                                        Aplicar filtro
                                                    </button>
                                                </div>
                                            </div>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                            </div>
                        </div>
                    </main>
                    <main className="bg-gray-50 px-7 h-full">
                        <div className="flex flex-wrap mt-4 gap-3">
                            {filters.date_after && <Badge text={`Desde: ${filters.date_after}`} handleDelete={() => deleteFromDate()} />}
                            {filters.date_before && <Badge text={`Hasta: ${filters.date_before}`} handleDelete={() => deleteToDate()} />}
                            {filters.studyFilter && filters.studyFilter.map((element) => (<Badge text={element.name} handleDelete={() => deleteStudyFilter(element.id)} />))}
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-6 h-full">
                            {dataPieA && <div className="bg-white p-5 w-full h-[400px] rounded-lg border"><Pie options={optionsPieA} data={dataPieA} /></div>}
                            {dataPieB && <div className="bg-white p-5 w-full h-[400px] rounded-lg border"><Pie options={optionsPieB} data={dataPieB} /></div>}
                        </div>
                        <div className="grid grid-cols-3 text-white w-1/2 gap-y-6 mt-4">
                            <div className="bg-[#FFBF96] rounded-l-lg shadow-sm py-5 px-4 h-36">
                                <p className="font-semibold leading-6">Estudios clínicos realizados</p>
                                <p className="text-2xl font-semibold leading-8">{data?.clinicalStudies.quantity}</p>
                            </div>
                            <div className="bg-[#FF7992] shadow-sm py-5 px-4 h-36 rounded-r-lg">
                                <p className="font-semibold leading-6">Estudios oftalmológicos realizados</p>
                                <p className="text-2xl font-semibold leading-8">{data?.ophthalmologicalStudies.quantity}</p>
                            </div>
                        </div>
                    </main>
                </div >
            }
        </div >
    );
}